import { FormFieldError } from "../form-field-error/FormFieldError.js";
import inputs_module_default from "../inputs.module.js";
import { TextInput } from "@mantine/core";
import { forwardRef, useCallback, useLayoutEffect, useMemo, useRef } from "react";
import { jsx } from "react/jsx-runtime";
import { IMaskInput } from "react-imask";

//#region src/components/inputs/text-input/TextInput.tsx
/**
*  A versatile input field for text-based interactions
*/
const TextInput$1 = forwardRef(({ autoFocus = false, description, disabled, error, flex, inputMode, label, leftSection, mask, name, onBlur, onChange, onClick, onFocus, onKeyUp, onPaste, placeholder, required, rightSection, role = "textbox", type, value, size = "xl", readOnly, defaultValue, "data-testid": testId }, forwardedRef) => {
	const internalRef = useRef(null);
	const ref = forwardedRef ?? internalRef;
	const hasValue = value?.toString().trim().length !== 0;
	useLayoutEffect(() => {
		if (autoFocus && ref.current) ref.current.focus();
	}, [autoFocus, ref]);
	const innerOnBlur = useCallback((event) => {
		if (ref.current && ref.current.type === "number" && !ref.current?.validity.valid) ref.current.value = value?.toString().trim() ?? "";
		onBlur?.(event);
	}, [
		onBlur,
		ref,
		value
	]);
	const err = useMemo(() => {
		if (error && typeof error === "boolean") return true;
		if (error && typeof error === "string") return /* @__PURE__ */ jsx(FormFieldError, { errText: error });
		return null;
	}, [error]);
	const maskProps = mask ? {
		component: IMaskInput,
		mask
	} : {};
	return /* @__PURE__ */ jsx(TextInput, {
		ref,
		"data-testid": testId,
		readOnly,
		classNames: inputs_module_default,
		description,
		value,
		label,
		disabled,
		inputMode,
		required,
		leftSection,
		rightSection,
		placeholder,
		name,
		onBlur: innerOnBlur,
		onChange,
		onClick,
		onFocus,
		onKeyUp,
		type,
		autoComplete: "off",
		radius: "xxs",
		size,
		flex,
		labelProps: { "data-floating": hasValue },
		error: err,
		descriptionProps: { className: disabled ? inputs_module_default.descriptionDisabled : inputs_module_default.description },
		inputWrapperOrder: error ? [
			"label",
			"input",
			"error"
		] : [
			"label",
			"input",
			"description"
		],
		onPaste,
		role,
		defaultValue,
		...maskProps
	});
});
TextInput$1.displayName = "TextInput";

//#endregion
export { TextInput$1 as TextInput };